<template>
  <div class="step-progress progress">
    <div class="bar">
      <span :class="`segment`" :style="getSegmentStyle(index)" v-for="index in total" :key="index">
      </span>
    </div>
    <div class="count">{{progressText}}</div>
  </div>
</template>

<style lang="less" scoped>
@import "./shared.less";
.step-progress {
  margin-bottom: 10px;
  .bar {
    width: 100%;
    display: flex;
    .segment {
      display: inline-block;
      margin: 3px 0;
      height: 5px;
      background: #42434c;
      display: flex;
      width: 100%;
      width: -webkit-fill-available;
      width: -moz-available;
      width: fill-available;
      margin-bottom: 5px;
      &.complete {
        background: orange;
      }
      &:first-child {
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
      }
      &:last-child {
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
      }
    }
  }
}
</style>

<script>
export default {
  props: {
    total: {
      type: Number
    }, 
    complete: {
      type: Number
    },
    completeSegmentColor: {
      type: String,
      default: "orange"
    },
    incompleteSegmentColor: {
      type: String,
      default: "#42434c"
    },
    completeBarColor: {
      type: String,
      default: "orange"
    },
    displayAsPercent: {
      type: Boolean,
      default: false
    },
    displayAsText: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    progressText() {
      if (this.displayAsPercent) {
        return `${Math.round((this.complete / this.total) * 100 )}%`
      } if (this.displayAsText) {
        return this.complete == this.total ? this.$t('message.complete') : this.$t('message.incomplete');
      } else {
        return this.$t('message.x-of-y', [this.complete, this.total]);
      }
    }
  },
  methods: {
    getSegmentStyle(index) {
      if (this.complete == this.total) {
        return {backgroundColor: this.completeBarColor};
      } else {
        return {backgroundColor: index > this.complete ? this.incompleteSegmentColor : this.completeSegmentColor};
      }
    }
  }
}
</script>